import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Container, Button, Col, Row } from 'react-bootstrap';
import Slider from "react-slick";
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
import { LazyLoadImage } from 'react-lazy-load-image-component';

function AdaniRealty() {
    window.scrollTo(0, 0);
    return (
        <div>
            <Helmet>

                <title>Adani Realty : $1 Million Homes, Sold to Multi-Millionaires</title>
                <meta name="description" content="" />
                <link rel="canonical" href="https://anbluxury.com/case-studies/adani-realty-case-study.html" />

            </Helmet>
            {/* first fold */}
            <div className="casestudy">
                <div className="box padmmdt padmmdb">

                    <Container>

                        <p className="text-left p1 pdl10"> <span class="spcase">ADANI</span> REALTY</p>
                    </Container>

                    <Container fluid className="padbsmt padbsmb">
                        <Row>
                            <Col lg="2"></Col>
                            <Col lg="8">
                                <div className="circleboxfirst  padssmb">
                                    <img src={`${process.env.PUBLIC_URL}/img/bgbox.png`} className="roundbx" width="30%" alt="" />

                                    <div className="boxcentered tpfold">
                                        <h4 className="d-none d-sm-block cuspn"> <span class=""> $1 Million </span> Homes,  <br />  Sold to <br /> Multi-Millionaires  <br /></h4>
                                        <h4 className="d-block d-sm-none"> <span class="cuspn"> $1 Million </span> Homes,  <br />  Sold to <br /> Multi-Millionaires  <br /></h4>

                                    </div>
                                </div>
                            </Col>
                            <Col lg="2"></Col>
                        </Row>
                    </Container>
                </div>
            </div>
            {/* The brand fold */}
            <div className="lgbox  problem">

                <Container fluid className="tpfold pdr0 mbpdr15">
                    <Row>
                        <Col lg="4" md="4" sm="6" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">

                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>BRAND</strong>  </p>
                            <p className="marbmdt mbt20 ">
                                Adani Realty is India’s leading real estate developer with a wide range of residential and commercial projects across the country.
                            </p>
                            <p className="">
                            They reached out to us for their ultra-luxury projects- The West Park & The North Park, Limited Edition Exclusive plots and villas; each worth a Million Dollars.
                            </p>
                        </Col>

                        <Col lg={{ span: 5, order: 'last' }} sm={{ span: 5, order: 'last' }} xs={{ span: 12, order: 'first' }} className="offset-lg-1 padmmdt mbpdr15">
                            <br></br>
                            <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/adani/adani-prop.png`} width="100%" height="100%" className="img-fluid text-right" />
                            <br></br>
                            <br></br>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* The opportunity */}


            <div className="box  problem padbxsb ">

                <Container fluid className="tpfold">
                    <Row>
                        <Col lg="8" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                            <p className="text-left p1 mrg30 " style={{ marginBottom: '50px' }}> <span class="spcase">THE</span> <strong>Problem</strong> </p>
                            <p className="">1. <strong>Low-Quality Leads:</strong> Their previous campaigns attracted leads primarily from lower-income groups, resulting in very few site visits for the project.</p>
                            <p className="">2. <strong>Perception:</strong> Since it is priced higher than similar projects in Ahmedabad, prospective buyers who could afford West Park often perceived the value as lacking.</p>
                        </Col>
                    </Row>
                </Container>
            </div>


            {/* Process */}
            <div className="lgbox  problem padbxsb">

                <Container fluid className="tpfold ">

                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">
                        <p className="text-left p1 mrg30 " style={{ marginBottom: '50px' }}> <span class="spcase">THE</span> <strong>Process</strong> </p>
                            <h2 className="tcgold marbxst marbxsb">OSIDE:</h2>
                            <p className="mbt20 ">
                                We leveraged our proprietary ad tool, OSIDE, to refine the inventory and specifically target Ultra High Net Worth Individuals (UHNIs) with demonstrated interest and intent.
                            </p>
                            <p className="mbt20 ">
                                By utilizing our extensive database, we targeted  key pincodes with the highest concentration of high net worth individuals in India, the UAE, the USA, and the UK, successfully generating quality leads from both domestic audiences and Indian expats seeking investment opportunities in India."

                            </p>
                        </Col>

                    </Row>



                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb padssmt">Revamping the Communication Strategy:</h2>
                            <Row>
                                <Col lg="7" md="6" sm="12" xs="12" className='p-0'>
                                    <p className="">After conducting a thorough analysis of the project based on key factors in luxury real estate, we gained a clear understanding of its positioning, unique selling points, and what our target audience desires. This allowed us to develop a revised communication strategy centered around three core aspects:
                                    </p>

                                    <ul style={{ listStyle: 'none' }}>
                                        <li>1. Scarcity</li>
                                        <li>2. Exclusivity.</li>
                                        <li>3. Value Appreciation.</li>
                                    </ul>
                                </Col>
                                <Col lg="5" md="6" sm="12" xs="12" className='p-0'>
                                    <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/adani/adani-insights.png`} width="100%" height="100%" className="img-fluid text-right" />
                                </Col>

                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb padssmt">Streamlining the sales process:</h2>
                            <Row>
                                <p className="">We implemented a WhatsApp Chatbot on the website to assist users with their queries and guide them towards scheduling site visits.</p>
                                <p className="">Our concierge service managed lead interactions, filtering and forwarding only high-intent, qualified leads to Adani Realty’s sales team. This allowed their team to focus exclusively on leads with strong potential, resulting in higher conversions.
                                </p>
                                <p className="">Additionally, we integrated Lead Profile Analysis into their CRM, enabling the sales team to know the background of each prospect—such as the CEO of a leading automobile manufacturer—so they could tailor their pitch effectively.
                                </p>
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb">Suggestions to improve the buying experience:</h2>
                            <p className="mbt20 ">
                                We also consulted the brand for improving their overall sales experience to make it more suited for a UHNI consumer.

                            </p>
                        </Col>

                        <Col lg={{ span: 10, order: 'last' }} sm={{ span: 10, order: 'last' }} xs={{ span: 12, order: 'last' }} className="offset-lg-1">
                            <Row>
                                <Col lg="4" md="4" sm="6" xs="12" className="mbpt0 casebox mt-3">
                                    <h4 className='tcgold'><span>Pre Visit</span> </h4>
                                    <br></br>
                                    <p>Real time lead enrichment</p>
                                    <p>Evolved Conversation with an Sales Manager</p>
                                    <p>Physical Invite for private viewing for qualified, enriched leads.
                                    </p>
                                    <p>Property Styling</p>
                                </Col>
                                <Col lg="4" md="4" sm="6" xs="12" className="mbpt0 casebox mt-3">
                                    <h4 className='tcgold'><span>During Visit</span> </h4>
                                    <br></br>
                                    <p>Arrange a Home Visit</p>
                                    <p>Communicate luxury via Belvedere Club </p>
                                    <p>Use a Chauffeur Service
                                    </p>
                                </Col>
                                <Col lg="4" md="4" sm="6" xs="12" className="mbpt0 casebox mt-3">
                                    <h4 className='tcgold'><span>Post Visit</span> </h4>
                                    <br></br>
                                    <p>Physical Proposal</p>
                                    <p>Manager level follow up, the relationship owner</p>
                                    <p>Value appreciation as part of sales pitch.
                                    </p>
                                    <p>Home visit follow up.</p>
                                </Col>

                            </Row>
                        </Col>
                    </Row>




                </Container>
            </div>
            {/* the impact */}
            <div className="lgbox  problem padbxsb">

                <Container fluid className="tpfold ">
                    <Row>

                        <Col lg="10" md="10" sm="10" xs="12" className="padmmdt mbpt0 casebox offset-lg-1 ">

                            <p className="text-left p1 mrg30 " > <span class="spcase">THE</span> <strong>IMPACT</strong> </p>


                          


                        </Col>

                        <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb padssmt">$1 Million Homes, Sold to Multi-Millionaires</h2>
                            <Row>
                                <p className="">For the first time in their history, they witnessed conversions for their ultra-luxury project driven entirely through digital channels.</p>
                            </Row>
                        </Col>
                    </Row>
                        <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb padssmt">Best Qualification Rate in history</h2>
                            <Row>
                                <p className="">They achieved a qualification rate of over 40%, the highest across all previous campaigns. One notable success included receiving a qualified sales inquiry worth $10 million from a single lead.</p>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="9" md="10" sm="10" xs="12" className="mbpt0 casebox offset-lg-1 ">
                            <h2 className="tcgold marbxst marbxsb padssmt">130+ UHNIs visited the project</h2>
                            <Row>
                                <p className="">Site visits surged dramatically, going from almost none to attracting CEOs and Directors from top businesses.</p>
                            </Row>
                        </Col>
                    </Row>
                    </Row>

                </Container>
            </div>

            <div className="lgbox build endbox">
                <Container fluid className="pdlr0">
                    <Row className="text-left  mglr0">

                        <Col lg="6" sm="6" xs="12">
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/isaia-retail-store-digital-transformation.html`}>
                                <Row className="marssmt marssmb mglr0">

                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/isaia.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">ISAIA </h4>
                                        <p>Store Footfalls increased by 100% in 4 months </p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>

                        <Col lg="6" sm="6" xs="12" className="bgbl " >
                            <Link to={`${process.env.PUBLIC_URL}/case-studies/ecommerce-conversion-rate-case-study.html`}>
                                <Row className="marssmt marssmb mglr0">
                                    <Col lg="3" sm="3" xs="3" >
                                        <LazyLoadImage effect="blur" src={`${process.env.PUBLIC_URL}/img/casestudy/footerlogo/saundh.png`} className="mx-auto img-fluid text-right" />
                                    </Col>
                                    <Col lg="5" sm="6" xs="7">

                                        <h4 className="tcgold">Saundh </h4>
                                        <p>5X Improvement in E-Commerce Conversion Rate.</p>
                                    </Col>
                                    <Col lg="2" sm="3" xs="2" className="marbxst">
                                        <img src={`${process.env.PUBLIC_URL}/img/righticon.png`} width="40%" className=" text-right" />
                                    </Col>
                                </Row>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>

    )
}
export default AdaniRealty;